import nftIcon from './nft-icon.png';

const NFTIcon = () => {
  return (
    <img src={nftIcon} alt="NFT Icon" className="nft-catalog-icon" />
  );
};

export default NFTIcon;
